window.HAS_CART = true

let mulberrySelectors = {
  cartItem: '.flex .mb-4 .pb-4 .border-beige .border-b',
  cartItemTitle: '.block.text-16px.tracking-1px.mb-2',
  cartAppendElement: '.text-14px.flex.flex-col.flex-auto',
  pdpForm: "button[name='add']",
  elementToAppendTo: '.sizing-chart-container',
  clickOrSubmit: 'click'
}

async function rebuildCart(state) {
    let items_div = ''

    for (let item of state.items) {

        let properties = ''

        for (const prop in item.properties) {
            properties += prop + ': ' + item.properties[prop] + '<br />'
        }

        const title = item.variant_title ? item.variant_title : ''

        const img = item.image ? item.image : '//cdn.shopify.com/s/files/1/0412/1994/8701/files/Screen_Shot_2021-03-04_at_2_59_16_PM.png'

        items_div += `
          <div class='flex mb-4 pb-4 border-beige border-b scoobydoo' style="${item.vendor == 'Mulberry' && 'display: none'}" data-mulberry-variant-id="${item.id}">
                <div class='mr-4'>
                    <div class='w-32'>
                        <div class='w-full pt-125 h-0 relative'>
                            <img src='${img}' class='w-full absolute inset-0 h-full object-contain' />
                        </div>
                    </div>
                </div>
                <div class='text-14px flex flex-col flex-auto'>
                    <div class='block text-16px tracking-1px mb-2'>
                        <strong>${item.product_title}</strong>
                    </div>
                    <div class='block mb-2'>
                        <div>${title}</div>
                    </div>
                    <div class='block mb-2 flex-auto leading-snug'>
                        ${properties}
                    </div>
                    <div class='block mb-2'>
                        <div>$${item.price / 100}</div>
                    </div>
                    <div class='flex justify-between w-full'>
                        <div class='w-full flex items-center mr-4'>
                            <button class='js-minus outline-none border border-beige px-3' data-key='${item.key}'>-</button>
                            <span class='px-4'>${item.quantity}</span>
                            <button href="#" class='js-plus outline-none border border-beige px-3' data-key='${item.key}'>+</button>
                        </div>
                        <div>
                            <button class='js-remove underline text-brown' data-key='${item.key}'>Remove</button>
                        </div>
                    </div>
					<div style="margin-top: 4px;">
					  <warranty-details data-variant-id="${item.id}"></warranty-details>
					</div>
                </div>
            </div>
        `
    }

    document.querySelector('.js-items').innerHTML = items_div
    document.querySelector('.js-price').innerHTML = '$' + (state.total_price / 100)

    const counts = document.querySelectorAll('.js-count')

    for (const count of counts) {
        count.innerHTML = state.item_count
    }

    const minus_elements = document.querySelectorAll('.js-minus')
        
    for (const minus of minus_elements) {
        minus.addEventListener('click', (e) => {
            const key = minus.dataset.key
            const item = state.items.find(item => item.key === key);

            const quantity = (item.quantity <= 1) ? 0 : (item.quantity - 1)
            $.ajax({
              type: "POST",
              url: '/cart/update.js',
              data: {
                    updates: {
                      [key]: quantity,
                    }
                  },
              success: function(state) {
                let newState = JSON.parse(state)
                if (window && window.mulberryShop) {
               	  mulberryShop.removeDetachedWarranty(newState)// Remove Warranties First 
                    .then(newCart => {
                      mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second 
                      .then(content => {
                          rebuildCart(content)
                      })
                    })
                } else {
                  rebuildCart(newState);
                }
              },
          });

//             cart.updateItem(key, { quantity }).then(state => {
//             });
        })
    }

    const plus_elements = document.querySelectorAll('.js-plus')
        
    for (const plus of plus_elements) {
        plus.addEventListener('click', (e) => {
            const key = plus.dataset.key
            const item = state.items.find(item => item.key === key);
            const quantity = item.quantity + 1

//             cart.updateItem(key, { quantity }).then(state => {
              $.ajax({
                type: "POST",
                url: '/cart/update.js',
                data: {
                      updates: {
                        [key]: quantity,
                      }
                    },
                success: function(state) {
                  let newState = JSON.parse(state)
                  if (window && window.mulberryShop) {
                    mulberryShop.removeDetachedWarranty(newState)// Remove Warranties First 
                      .then(newCart => {
                        mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second 
                        .then(content => {
                            rebuildCart(content)
						  const new_item = content.items.find(item => item.key === key);

                          if (new_item.quantity == item.quantity) {
                              alert('No further inventory available!')    
                          }
                        })
                      })
                  } else {
                    rebuildCart(newState);
						  const new_item = newState.items.find(item => item.key === key);

                          if (new_item.quantity == item.quantity) {
                              alert('No further inventory available!')    
                          }
                  }
                },
            });
//                 const new_item = state.items.find(item => item.key === key);

//                 if (new_item.quantity == item.quantity) {
//                     alert('No further inventory available!')    
//                 }
//                 
//                 rebuildCart(state);
//             }).catch(function (e) {
//                 alert('No further inventory available!')
//             })
        })
    }

    const remove_elements = document.querySelectorAll('.js-remove')


    for (const remove of remove_elements) {
        remove.addEventListener('click', (e) => {
            const key = remove.dataset.key

//             cart.removeItem(key).then(state => {
//                 rebuildCart(state);
//             });
            $.ajax({
              type: "POST",
              url: '/cart/update.js',
              data: {
                    updates: {
                      [key]: 0,
                    }
                  },
              success: function(state) {
                let newState = JSON.parse(state)
                if (window && window.mulberryShop) {
               	  mulberryShop.removeDetachedWarranty(newState)// Remove Warranties First 
                    .then(newCart => {
                      mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second 
                      .then(content => {
                          rebuildCart(content)
                      })
                    })
                } else {
                  rebuildCart(newState);
                }
              },
          });
        })
    }
  
  await mulberryShop.cart.init()
  mulberryShop.cart.render()
}

function refreshCart(content) {
  price = content.items_subtotal_price
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: content.currency,
    minimumFractionDigits: 0 
  });
  total = formatter.format(Math.round(price / 100, 0))
  $(".js-price").text(total)
}

function getCurrentlySelectedVariant(variants) {
  queryString = window.location.search
  urlParams = new URLSearchParams(queryString)
  variantId = urlParams.get('variant')
  if(variantId === null) {
    variantId = mulberryShop.selectedVariantId
  }
  mulberryShop.selectedVariantId = variantId
  selectedVariant = variants.find(i => i.id == variantId)
  return selectedVariant
}

function setupCustomVariantChange() {
  $(".radio-item").each(
    function(idx, el){
      $(el).on('change', function(){
        productInfo = {variantId: ''} // this will suppress an adapter error
        variantChangeEvent = new CustomEvent("mulberry-shopify:variant-change", {detail: productInfo})
        document.dispatchEvent(variantChangeEvent)
      })})
  // something to get product Info
  //productInfo = undefined
  //variantChangeEvent = new CustomEvent("mulberry-shopify:variant-change", {detail: productInfo})
  //document.dispatchEvent(variantChangeEvent)
}

async function createCart() {
       await fetch('/cart.js', {
         credentials: 'same-origin',
         method: 'GET',
         headers: {
           'Content-Type': 'application/json',
           'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
         }
       }).then(function (cart) {
         cart.json().then(function (firstCart) {     
              rebuildCart(firstCart)             
         });
       });

}

async function updateCartWidgetInfo() {     
  $("warranty-details").each(function(idx, item){$(item).remove()})
  document.querySelectorAll('.js-items')[0].children.forEach(function(item){
    variantId = $(item).find('.js-minus').attr('data-key')
    let justId = variantId.split(':')
    
    item.setAttribute('data-mulberry-variant-id', justId[0])
    if($(item).find(mulberrySelectors.cartItemTitle).text().trim().includes('Mulberry Protection')) {
//       item.setAttribute('style', 'display: none;')
    }
    else {
      item.setAttribute('style', '')
    }
    var div = $(`<div style="max-width: 250px"/>`)
    var $newWarrantyDetails = $(`<warranty-details/>`).attr('data-variant-id', justId[0])
    var add = div.append($newWarrantyDetails)    
    $(item).find(mulberrySelectors.cartAppendElement).append(add)    
  })
    await mulberryShop.cart.init()
    mulberryShop.cart.render()  
}


async function setCartInfoAndRender(content, init=true) {
  refreshCart(content)
  await createCart()
//   updateCartWidgetInfo()            
  if(window.HAS_CART) {
    if(init){
      await mulberryShop.cart.init()
    }
    mulberryShop.cart.render()
  }
}


if(typeof mulberryShop !== 'undefined' && mulberryShop.paths && mulberryShop.paths.shopifyAdapter) {
   if (window.location.href.includes('/products/')) { 
     mulberryPdpInit()
   } 
   removeAndSyncWarranties()
   setupAjaxListeners()
   addCartEventListeners()
}
else {
//   document.addEventListener('mulberry-shopify:loaded', () => {
//    if (window.location.href.includes('/products/')) {  
//      mulberryPdpInit()
//    } 
//    removeAndSyncWarranties()
//    setupAjaxListeners()
//    addCartEventListeners()
//   })
}

document.addEventListener('mulberry-shopify:loaded', function() {
   if (window.location.href.includes('/products/')) {  
     mulberryPdpInit()
   }
   removeAndSyncWarranties()
   setupAjaxListeners()
   addCartEventListeners()
   $('.js-open-cart').on('click', () => {
	removeAndSyncWarranties()            
})
})

function createOtherListener() {
   	$pdpForm = $(mulberrySelectors.pdpForm)
    $pdpForm.on(mulberrySelectors.clickOrSubmit, async function(e){
    	removeAndSyncWarranties()
    })
}

async function mulberryPdpInit() {

  HAS_MODAL = mulberry.core.settings.has_modal
  HAS_INLINE = mulberry.core.settings.has_inline

  if(window.location.pathname.indexOf("/products/") === -1) {
    return
  }

  if(!HAS_MODAL && !HAS_INLINE) {
    return
  }

  setupCustomVariantChange()
  if(HAS_INLINE) {
    let mulberryDiv = document.createElement('div')
    mulberryDiv.classList.add('mulberry-inline-container')

    $(`#mulberry-target-inline`).append(mulberryDiv)    
  }

  let response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
  let product = response.product;
  let selectedVariant = getCurrentlySelectedVariant(product.variants)
  const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
  })

  if(offers.length === 0){
    document.addEventListener("shopify:cart-add", function() {
      setTimeout(function(){ 
        //mulberryShop.cart.render() 
      }, 650);
    })
    createOtherListener()
    return
  }

  const { settings } = mulberry.core;
  let selectedOffer;
  if(HAS_INLINE){
    window.pdpInline = await mulberry.inline.init({
        layout: {logo: false},
        offers: offers, 
        settings: mulberry.core.settings,
        selector: '.mulberry-inline-container',
        onWarrantyToggle: async (warranty) => {
          mulberry.inline.isSelected = warranty.isSelected
          if(warranty.isSelected) {
            selectedOffer = warranty.offer
          }
          else {
            selectedOffer = null
          }
        }
      })
  }
  if(HAS_MODAL){
    window.pdpModal = await mulberry.modal.init({
        offers: offers, 
        settings: mulberry.core.settings,
        onWarrantySelect: async (warranty) => {
          const result = await mulberryShop.getWarrantyVariant(warranty);
          await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, warranty);
          mulberry.modal.close();
          removeAndSyncWarranties()
        },
        onWarrantyDecline: () => {
          mulberry.modal.close();
          removeAndSyncWarranties()
        }
      })
  }


  document.addEventListener('mulberry-shopify:variant-change', async function(e) {
    window.pdpInline.deselectOffer()
    selectedOffer = null
    selectedVariant = getCurrentlySelectedVariant(product.variants)
    const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
    })

    if(HAS_INLINE){
      window.pdpInline.updateOffer(offers);
    }
    if(HAS_MODAL) {
      window.pdpModal.updateOffer(offers)
    }

  });

  $pdpForm = $(mulberrySelectors.pdpForm)
  $pdpForm.on(mulberrySelectors.clickOrSubmit, async function(e){ 
    if(HAS_INLINE && selectedOffer) {
      window.pdpInline.deselectOffer()
      setTimeout(async function(){
       const result = await mulberryShop.getWarrantyVariant(selectedOffer);
       await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, selectedOffer);
       removeAndSyncWarranties()
       selectedOffer = null
      }, 250)
      $pdpForm.submit()
      return
    } 

    else if(HAS_MODAL) {       
      window.pdpModal.open()
      return
    }

    if(selectedOffer) {     
      setTimeout(async function(){
       window.pdpInline.deselectOffer()
       const result = await mulberryShop.getWarrantyVariant(selectedOffer);
       await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, selectedOffer);
       removeAndSyncWarranties()
       selectedOffer = null
      }, 250)  
    }
    else {
      setTimeout(() => {
        removeAndSyncWarranties()                 
	  }, 2000)
//       window.pdpModal.open()
    }
  })
}



async function removeAndSyncWarranties(reload=false) {
  await fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      cart.json().then(function (firstCart) {
        mulberryShop.removeDetachedWarranty(firstCart)// Remove Warranties First 
        .then(newCart => {
          mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second 
          .then(content => {         
              setCartInfoAndRender(content)
          })
        })
      });
    })
}

document.addEventListener('mulberry-shopify:warranty-added', () => {
  removeAndSyncWarranties();
});


function setupAjaxListeners() {
    // Set up listeners to fire the pixel if/when the user peforms specific actions that trigger ajax requests.
    // Since we cant create globals we test for the XMLHttpRequest overwrite
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock fetch() in order to determine if we should mock then() as well
        var mbFetch = fetch;
        fetch = function() {
            var url = arguments[0];
            var body = '';
            if ((arguments.length > 1) && (typeof arguments[1].body !== 'undefined'))
            {
                body = arguments[1].body;
            }
            var promise = mbFetch.apply(this,arguments);
            if (url && url.indexOf('cart/change') !== -1) {
                //If its a product being added to cart we add a function to track it
                promise = promise.then(function (response) {
                    if (response.ok) {
                        //trackAjaxAddToCart(body, response.clone().json());
                    }
                    return response;
                });
            }
            return promise;
        };
    }
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock the XMLHttpRequest open method in order to determine if we should mock the send method
        XMLHttpRequest.prototype.mbOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
            var url = arguments[1];
            if (url && ( (url.includes('cart/change')) || (url.includes('cart/add')) || (url.includes('cart/update')) )) {
                // We mock the instance's send method if the request is to the "add to the cart" url.
                this.mbSend = this.send;
                this.send = function (value) {
                    try {
                        if (value) {
                            var self = this; // The xhttp request object

                            var trackOnSuccess = function () {
                                if (self.readyState === 4 && self.status === 200) {
                                  if(self.responseURL !== undefined) {
                                    if(self.responseURL.includes('cart/add')){
                                      addCustomEvent = new CustomEvent("shopify:cart-add")
                                      document.dispatchEvent(addCustomEvent)
                                    }
                                    if(self.responseURL.includes('cart/change')) {
                                      changeCustomEvent = new CustomEvent("shopify:cart-change")
                                      document.dispatchEvent(changeCustomEvent)
                                    }
                                    if(self.responseURL.includes('cart/update')) {
                                      updateCustomEvent = new CustomEvent("shopify:cart-update")
                                      document.dispatchEvent(updateCustomEvent)
                                    }
                                  }
                                }
                            };

                            if (typeof self.addEventListener !== 'undefined') {
                                self.addEventListener('readystatechange', trackOnSuccess);
                            } else {
                                if (typeof self.onreadystatechange !== 'undefined' && self.onreadystatechange !== null) {
                                    // If the xhttp object already has an onreadystatechange callback, make sure we preserve it.
                                    self.mbOnreadystatechange = self.onreadystatechange;
                                    self.onreadystatechange = function () {
                                        self.mbOnreadystatechange();
                                        trackOnSuccess();
                                    };
                                } else {
                                  // If there is no onreadystatechange callback, we can safely set it.
                                  self.onreadystatechange = trackOnSuccess;
                                }
                            }
                        }
                    } catch(e) {
                        // if something goes wrong tracking the addToCart,
                        // we just ignore it and prevent the website from breaking.
                        console.log(e);
                    }
                    this.mbSend(value);
                };
            }
            this.mbOpen.apply(this, arguments);
        };
    }
}


function addCartEventListeners() {
  document.addEventListener('shopify:cart-change', removeAndSyncWarranties)
  document.addEventListener('mulberry-shopify:warranty-added', removeAndSyncWarranties)
} 